export enum ModuleType {
	MY = "MY",
	TEAM = "TEAM",
	APPOINTMENT = "APPOINTMENT",
	PAYROLL = "PAYROLL",
	PERFORMANCE = "PERFORMANCE",
	CAREER = "CAREER",
	RECRUITMENT = "RECRUITMENT",
	REMUNERATION = "REMUNERATION",
	MOODS = "MOODS",
	CORPORATE_WALL = "CORPORATE_WALL",
	RESUME = "RESUME",
	SST = "SST"
}

export enum AnalyticType {
	MANAGER = "MANAGER",
	HR = "HR",
	LED = "LED",
	MY = "MY"
}


export enum SectionModuleType {
	LED = "LED",
	FEATURES = "FEATURES"
}

export enum XAxisType {
	LINEAR = "linear",
	LOGARITHMIC = "logarithmic",
	DATETIME = "datetime",
	CATEGORY = "category"
}

export enum ChartTypes {
	LINE = "line",
	SPLINE = "spline",
	AREA = "area",
	AREASPLINE = "areaspline",
	COLUMN = "column",
	BAR = "bar",
	PIE = "pie",
	SCATTER = "scatter",
	GAUGE = "gauge",
	AREARANGE = "arearange",
	AREASPLINERANGE = "areasplinerange",
	COLUMNRANGE = "columnrange"
}

export enum Devices {
	DESKTOP,
	TABLET,
	MOBILE
}

export enum ModuleName {
	// "Painel de Gestão"
	MANAGEMENT_PANEL = "MANAGEMENT_PANEL",
	// "Gestão de Desempenho"
	PERFORMANCE_MANAGEMENT = "PERFORMANCE_MANAGEMENT",
	// "Carreira e Sucessão"
	CAREER_SUCCESSION = "CAREER_SUCCESSION",
	// "Recrutamento e Seleção"
	RECRUIT_MANAGEMENT = "RECRUIT_MANAGEMENT",
	// "Gestão de Remuneração"
	REMUNERATION_MANAGEMENT = "REMUNERATION_MANAGEMENT",
	// "Gestão de Desenvolvimento"
	DEVELOPMENT_MANAGEMENT = "DEVELOPMENT_MANAGEMENT",
	// "Folha de Pagamento"
	PAYROLL = "PAYROLL",
	// "Aplicativo"
	APP = "APP",
	// "Pesquisa de clima contínua (Moods)"
	MOODS = "MOODS",
	// "e-Social (Nuvem)"
	ESOCIAL = "ESOCIAL"
}
